import React from "react";
import { useMediaQuery } from "@mui/material";
import StagesMobile from "./StagesMobile";
import StagesDesktop from "./StagesDesktop";

const CodingChallengeStages = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  return isMobile ? <StagesMobile /> : <StagesDesktop />;
};

export default CodingChallengeStages;
